import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const CheckBoxSmallFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg width="25" height="25" viewBox="-2 -4 24 24" fill="none" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.07.2h7.85a4.87 4.87 0 0 1 4.87 4.87v7.85a4.87 4.87 0 0 1-4.87 4.87H5.07A4.87 4.87 0 0 1 .2 12.92V5.07A4.87 4.87 0 0 1 5.07.2Zm8.616 6.366a.8.8 0 0 0-1.132-1.132l-5.503 5.504-2.054-2.063a.8.8 0 0 0-1.134 1.13l2.62 2.63a.8.8 0 0 0 1.133 0l6.07-6.07Z"
      fill={color}
    />
  </Svg>
)

export default CheckBoxSmallFilled
